var abilitiesFre = {
    "1": "Puanteur",
    "2": "Crachin",
    "3": "Turbo",
    "4": "Armurbaston",
    "5": "Fermeté",
    "6": "Moiteur",
    "7": "Échauffement",
    "8": "Voile Sable",
    "9": "Statik",
    "10": "Absorbe-Volt",
    "11": "Absorbe-Eau",
    "12": "Ben\u00eat",
    "13": "Ciel Gris",
    "14": "\u0152il Composé",
    "15": "Insomnia",
    "16": "Homochromie",
    "17": "Vaccin",
    "18": "Torche",
    "19": "Écran Poudre",
    "20": "Tempo Perso",
    "21": "Ventouse",
    "22": "Intimidation",
    "23": "Marque Ombre",
    "24": "Peau Dure",
    "25": "Garde Mystik",
    "26": "Lévitation",
    "27": "Pose Spore",
    "28": "Synchro",
    "29": "Corps Sain",
    "30": "Médic Nature",
    "31": "Paratonnerre",
    "32": "Sérénité",
    "33": "Glissade",
    "34": "Chlorophylle",
    "35": "Lumiattirance",
    "36": "Calque",
    "37": "Coloforce",
    "38": "Point Poison",
    "39": "Attention",
    "40": "Armumagma",
    "41": "Ignifu-Voile",
    "42": "Magnépi\u00e8ge",
    "43": "Anti-Bruit",
    "44": "Cuvette",
    "45": "Sable Volant",
    "46": "Pression",
    "47": "Isograisse",
    "48": "Matinal",
    "49": "Corps Ardent",
    "50": "Fuite",
    "51": "Regard Vif",
    "52": "Hyper Cutter",
    "53": "Ramassage",
    "54": "Absentéisme",
    "55": "Agitation",
    "56": "Joli Sourire",
    "57": "Plus",
    "58": "Moins",
    "59": "Météo",
    "60": "Glu",
    "61": "Mue",
    "62": "Cran",
    "63": "Écaille Spéciale",
    "64": "Suintement",
    "65": "Engrais",
    "66": "Brasier",
    "67": "Torrent",
    "68": "Essaim",
    "69": "T\u00eate de Roc",
    "70": "Sécheresse",
    "71": "Pi\u00e8ge Sable",
    "72": "Esprit Vital",
    "73": "Écran Fumée",
    "74": "Force Pure",
    "75": "Coque Armure",
    "76": "Air Lock",
    "77": "Pieds Confus",
    "78": "Motorisé",
    "79": "Rivalité",
    "80": "Impassible",
    "81": "Rideau Neige",
    "82": "Gloutonnerie",
    "83": "Colérique",
    "84": "Délestage",
    "85": "Ignifugé",
    "86": "Simple",
    "87": "Peau S\u00e8che",
    "88": "Télécharge",
    "89": "Poing de Fer",
    "90": "Soin Poison",
    "91": "Adaptabilité",
    "92": "Multi-Coups",
    "93": "Hydratation",
    "94": "Force Soleil",
    "95": "Pied Véloce",
    "96": "Normalise",
    "97": "Sniper",
    "98": "Garde Magik",
    "99": "Annule Garde",
    "100": "Frein",
    "101": "Technicien",
    "102": "Feuille Garde",
    "103": "Maladresse",
    "104": "Brise Moule",
    "105": "Chanceux",
    "106": "Boom Final",
    "107": "Anticipation",
    "108": "Prédiction",
    "109": "Inconscient",
    "110": "Lentiteintée",
    "111": "Filtre",
    "112": "Début Calme",
    "113": "Querelleur",
    "114": "Lavabo",
    "115": "Corps Gel",
    "116": "Solide Roc",
    "117": "Alerte Neige",
    "118": "Cherche Miel",
    "119": "Fouille",
    "120": "Téméraire",
    "121": "Multi-Type",
    "122": "Don Floral",
    "123": "Mauvais R\u00eave",
    "124": "Pickpocket",
    "125": "Sans Limite",
    "126": "Contestation",
    "127": "Tension",
    "128": "Acharné",
    "129": "Défaitiste",
    "130": "Corps Maudit",
    "131": "C\u0153ur Soin",
    "132": "Garde-Ami",
    "133": "Armurouillée",
    "134": "Heavy Metal",
    "135": "Light Metal",
    "136": "Multiécaille",
    "137": "Rage Poison",
    "138": "Rage Br\u00fblure",
    "139": "Récolte",
    "140": "Télépathe",
    "141": "Lunatique",
    "142": "Envelocape",
    "143": "Toxitouche",
    "144": "Régé-Force",
    "145": "C\u0153ur de Coq",
    "146": "Baigne Sable",
    "147": "Peau Miracle",
    "148": "Analyste",
    "149": "Illusion",
    "150": "Imposteur",
    "151": "Infiltration",
    "152": "Momie",
    "153": "Impudence",
    "154": "C\u0153ur Noble",
    "155": "Phobique",
    "156": "Miroir Magik",
    "157": "Herbivore",
    "158": "Farceur",
    "159": "Force Sable",
    "160": "Épine de Fer",
    "161": "Mode Transe",
    "162": "Victorieux",
    "163": "Turbo Brasier",
    "164": "Téra-Voltage",
    "165": "Aroma-Voile",
    "166": "Flora-Voile",
    "167": "Bajoues",
    "168": "Protéen",
    "169": "Toison Épaisse",
    "170": "Magicien",
    "171": "Pare-Balles",
    "172": "Battant",
    "173": "Prognathe",
    "174": "Peau Gelée",
    "175": "Gluco-Voile",
    "176": "Déclic Tactique",
    "177": "Ailes Bourrasque",
    "178": "Méga Blaster",
    "179": "Toison Herbue",
    "180": "Symbiose",
    "181": "Griffe Dure",
    "182": "Peau Féérique",
    "183": "Poisseux",
    "184": "Peau Céleste",
    "185": "Amour Filial",
    "186": "Aura Ténébreuse",
    "187": "Aura Féérique",
    "188": "Aura Inversée",
    "189": "Mer Primaire",
    "190": "Terre Finale",
    "191": "Souffle Delta",
    "192": "Endurance",
    "193": "Escampette",
    "194": "Repli Tactique",
    "195": "Sable Humide",
    "196": "Cruauté",
    "197": "Bouclier-Carcan",
    "198": "Filature",
    "199": "Aquabulle",
    "200": "Expert Acier",
    "201": "Folle Furie",
    "202": "Chasse-Neige",
    "203": "Longue Portée",
    "204": "Hydrata-Son",
    "205": "Prioguérison",
    "206": "Peau Électrique",
    "207": "Surf Caudal",
    "208": "Banc",
    "209": "Fant\u00f4masque",
    "210": "Synergie",
    "211": "Rassemblement",
    "212": "Corrosion",
    "213": "Hypersommeil",
    "214": "Prestance Royale",
    "215": "Expuls'Organes",
    "216": "Danseuse",
    "217": "Batterie",
    "218": "Boule de Poils",
    "219": "Corps Coloré",
    "220": "Animac\u0153ur",
    "221": "M\u00e8che Rebelle",
    "222": "Receveur",
    "223": "Osmose",
    "224": "Boost Chim\u00e8re",
    "225": "Syst\u00e8me Alpha",
    "226": "Créa-Élec",
    "227": "Créa-Psy",
    "228": "Créa-Brume",
    "229": "Créa-Herbe",
    "230": "Métallo-Garde",
    "231": "Spectro-Bouclier",
    "232": "Prisme-Armure",
    "233": "Cérébro-Force",
    "234": "Lame Indomptable",
    "235": "Égide Inflexible",
    "236": "Libéro",
    "237": "Ramasse Ball",
    "238": "Effilochage",
    "239": "Propulseur",
    "240": "Armure Miroir",
    "241": "Dégobage",
    "242": "Nerfs d'Acier",
    "243": "Turbine",
    "244": "Punk Rock",
    "245": "Expul'Sable",
    "246": "Écailles Glacées",
    "247": "M\u00fbrissement",
    "248": "T\u00eate de Gel",
    "249": "Cercle d'Énergie",
    "250": "Mimétisme",
    "251": "Brise-Barri\u00e8re",
    "252": "Boost Acier",
    "253": "Corps Condamné",
    "254": "\u00c2me Vagabonde",
    "255": "Ent\u00eatement",
    "256": "Gaz Inhibiteur",
    "257": "Voile Pastel",
    "258": "Déclic Fringale",
    "259": "Tir Vif",
    "260": "Poing Invisible",
    "261": "Breuvage Suspect",
    "262": "Transistor",
    "263": "Dent de Dragon",
    "264": "Blanche Ruade",
    "265": "Sombre Ruade",
    "266": "Osmose Équine",
    "267": "Osmose Équine",
    "268": "Odeur Tenace",
    "269": "Semencier",
    "270": "Thermodynamique",
    "271": "Courroupace",
    "272": "Sel Purificateur",
    "273": "Bien Cuit",
    "274": "Aéroporté",
    "275": "Chien de Garde",
    "276": "Porte-Roche",
    "277": "Turbine Éolienne",
    "278": "Supermutation",
    "279": "Commandant",
    "280": "Grecharge",
    "281": "Paléosynth\u00e8se",
    "282": "Charge Quantique",
    "283": "Corps en Or",
    "284": "Urne du Fléau",
    "285": "Épée du Fléau",
    "286": "Bois du Fléau",
    "287": "Perles du Fléau",
    "288": "Pouls Orichalque",
    "289": "Moteur \u00e0 Hadrons",
    "290": "Opportuniste",
    "291": "Ruminant",
    "292": "Incisif",
    "293": "Général Supr\u00eame",
    "294": "Collab",
    "295": "Dép\u00f4t Toxique",
    "296": "Armure Caudale",
    "297": "Absorbe-Terre",
    "298": "Force Fongique",
    "299": "Aux Petits Soins",
    "300": "\u0152il Révélateur",
    "301": "Force Mémorielle",
    "302": "Force Mémorielle",
    "303": "Force Mémorielle",
    "304": "Force Mémorielle",
    "305": "Cha\u00eene Toxique",
    "306": "Nectar Mielleux",
    "307": "Téramorphose",
    "308": "Téra-Carapace",
    "309": "Téraformation 0"
}
export default abilitiesFre;